import { loadRemote, registerRemotes } from '@module-federation/runtime';

const DS_REMOTE = 'shipbob_design_system';
let designSystem = null;

/** Registers the design-system remote and loads it once; throws if the URL is missing or invalid or the remote does not load. */
export async function loadDesignSystem(designSystemUrl) {
  if (designSystem) return;
  if (typeof designSystemUrl !== 'string' || !designSystemUrl.trim()) {
    throw new Error('[order-shipment-management-ui] the design-system URL is missing or invalid');
  }
  const origin = designSystemUrl.trim().replace(/\/+$/, '');

  // type 'var': the DS is a webpack MF v1 container that assigns window.shipbob_design_system.
  registerRemotes([{ name: DS_REMOTE, type: 'var', entry: `${origin}/remoteEntry.js` }], { force: true });
  const loaded = await loadRemote(DS_REMOTE);
  if (!loaded) throw new Error(`[order-shipment-management-ui] the design system did not load from ${origin}`);
  designSystem = loaded;
}

/** Synchronous accessor for the loaded design system; throws if loadDesignSystem() has not resolved yet. */
export function useDesignSystem() {
  if (!designSystem)
    throw new Error('[order-shipment-management-ui] the design system was used before loadDesignSystem() resolved it');
  return designSystem;
}

/** Test-only: clears the module-level singleton so specs do not depend on declaration order. */
export function __resetForTests() {
  designSystem = null;
}
